module.exports = __webpack_public_path__ + "static/media/defaultlogo.20b5e4b7.png";